module.exports = __webpack_public_path__ + "static/img/logo.9176735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/logo.png
// module id = wJt1
// module chunks = 0